import React from 'react';
import { connect } from 'react-redux';
import sensorsActions from '../../../../actions/sensors.actions';
import helper from '../../../../utils/helper';
import qs from 'qs';
import SensorInfoPage from './SensorInfoPage';

class SensorInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      sensorInfo: [],
      errors: '',
    };
    this.columns = [
      {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: { width: '10%' },
      },
      {
        dataField: 'location',
        text: 'Location',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'model',
        text: 'Model',
        sort: true,
        headerStyle: { width: '10%' },
      },
      {
        dataField: 'serialNo',
        text: 'Serial No',
        sort: true,
        headerStyle: { width: '10%' },
      },
      {
        dataField: 'description',
        text: 'Remote',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'sensorType',
        text: 'Type',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'sensorSettingAlarms',
        text: 'Alerts',
        sort: true,
      },
      {
        dataField: 'active',
        text: 'Override',
        formatter: (cell) => (cell ? false : true),
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'alarmsEnabled',
        text: 'Alarms',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'loggingEnabled',
        text: 'Logging',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'daenabled',
        text: 'Data Acq.',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'alarmDelay',
        text: 'Delay',
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'units',
        text: 'Units',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'la',
        text: '<<',
        headerStyle: { width: '5%' },
        headerTitle: () => 'Low Alarm',
        formatter: (cell, row) => this.oparFormatter(row.la, row.arLa),
      },
      {
        dataField: 'lw',
        text: '<',
        headerStyle: { width: '5%' },
        headerTitle: () => 'Low Warning',
        formatter: (cell, row) => this.oparFormatter(row.lw, row.arLw),
      },
      {
        dataField: 'hw',
        text: '>',
        headerStyle: { width: '5%' },
        headerTitle: () => 'High Warning',
        formatter: (cell, row) => this.oparFormatter(row.hw, row.arHw),
      },
      {
        dataField: 'ha',
        text: '>>',
        headerStyle: { width: '5%' },
        headerTitle: () => 'High Alarm',
        formatter: (cell, row) => this.oparFormatter(row.ha, row.arHa),
      },
      {
        dataField: 'sensorId',
        text: 'ID',
        sort: true,
        headerStyle: { width: '5%' },
      },
      {
        dataField: 'calibrationDate',
        text: 'Calibration Date',
        sort: true,
        isDateTime: true,
      },
    ];
    this.defaultSorted = [
      {
        dataField: 'name',
        order: 'asc',
      },
    ];
  }
  oparFormatter = (inOpt, atRest) => (
    <div title="In Operation / At Rest">
      {`${inOpt ? inOpt : ''}/${atRest ? atRest : ''}`}
    </div>
  );
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    // if (nextProps.sensors.sensorInfo !== prevState.sensorInfo) {
    //   state.sensorInfo = nextProps.sensors.sensorInfo;
    // }
    if (nextProps.sensors.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.sensors.isFetching;
    }
    state.errors = helper.centralizeError([nextProps.sensors.errors]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { sensorIds } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (sensorIds) {
      this.props
        .getSensorInfo(sensorIds)
        .then((sensorInfo) => this.setState({ sensorInfo }))
        .catch((err) => console.log(err));
    }
  }
  render() {
    const { sensorIds } = helper.parseQueryString(this.props.location.search);
    return (
      <SensorInfoPage
        {...this.state}
        sensorIds={sensorIds}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    sensors: state.sensors,
  };
}

export default connect(mapStateToProps, sensorsActions)(SensorInfo);
